module.exports = __webpack_public_path__ + "img/Monte_Kope_11.cf22e0fd.jpg";